import { compose } from 'redux';
import { connect } from 'react-redux';
import selectors from '../../../rootSelectors';
import PBView from '../../PBView';
import * as multiChoiceUtils from '../../../common/questions/multiChoiceQuestionUtils';
import {
    playResponseAudio, selectPossibleResponse, resetQuestionsAndTimeTrackingState,
    resetSelectedIndex,
} from '../../../common/questions/questionsActions';
import { setAvatarInstructions } from '../../../common/avatar/avatarActions';
import { blockScreen, unblockScreen, unmountScreen } from '../../../common/screen/screenActions';
import { fetchPBContent } from '../../pbActions';
import { narrateStart, narrateReset, stopAudio } from '../../../common/audio/audioActions';
import { narrateQuestionsScreen, onNextButtonClick } from './PBQuestionsActions';
import { getQuestionIndex } from '../../../common/utils/urlParsers';
import AvatarView from '../../../common/avatar/avatarView';
import withAvatar from '../../../common/avatar/withAvatar';
import PB_AUDIO_INSTRUCTIONS from '../../pbConstants';
import { QUESTIONS } from '../../../constants/assessmentItemType';
import { PB } from '../../../constants/measure';
import { playStimulusAudio } from '../../../common/stimulus/stimulusButtonActions';
import { GENERAL_AUDIO_DELAY } from '../../../constants/time';

const mapStateToProps = (state, ownProps) => {
    const props = multiChoiceUtils.mapStateToProps(state);
    const questionIndex = getQuestionIndex(ownProps.match.params);
    return {
        ...props,
        pageLayout: `${PB.ASSESSMENT}`,
        isDataFetched: selectors.getIsPBDataFetched(state),
        possibleResponses: selectors.getPBPossibleResponses(state, QUESTIONS, questionIndex - 1),
        questionSpecificAudio: selectors.getPBQuestionSpecificAudio(state, QUESTIONS,
            questionIndex - 1),
        playingResponseIndex: selectors.getPlayingResponseIndex(state),
        questionIndex,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const props = multiChoiceUtils.mapDispatchToProps(dispatch);
    const questionIndex = getQuestionIndex(ownProps.match.params);
    return {
        ...props,
        fetchContent: () => {
            dispatch(fetchPBContent());
        },
        setAvatarInstructions: (questionSpecificAudio) => {
            dispatch(setAvatarInstructions([
                PB_AUDIO_INSTRUCTIONS.questionsInstruction,
                ...questionSpecificAudio,
            ]));
        },
        narrateStimulus: (stimulusAudio) => {
            dispatch(playStimulusAudio(
                stimulusAudio,
                GENERAL_AUDIO_DELAY,
            ));
        },
        narrateScreen: async (questionSpecificAudio, possibleResponses) => {
            dispatch(blockScreen());
            dispatch(narrateStart());
            await dispatch(narrateQuestionsScreen(
                questionSpecificAudio,
                possibleResponses,
            ));
            dispatch(resetSelectedIndex());
            dispatch(narrateReset());
            dispatch(unblockScreen());
        },
        selectResponse: (index) => {
            dispatch(selectPossibleResponse(index));
            // Timeout for better UX / UI
            setTimeout(() => {
                dispatch(onNextButtonClick(questionIndex));
            }, 200);
        },
        responseAudioClick: async (audio, index) => {
            dispatch(blockScreen());
            await dispatch(playResponseAudio(audio, index));
            dispatch(unblockScreen());
        },
        cleanup: () => {
            dispatch(stopAudio());
            dispatch(narrateReset());
            dispatch(resetQuestionsAndTimeTrackingState());
            dispatch(unmountScreen());
        },
    };
};

const avatarMapStateToProps = () => ({
    position: AvatarView.Position.LOWER_LEFT,
});

const PBQuestionsContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(PBView);

export default PBQuestionsContainer;
